module.exports = "<div ng-class=\"{ &quot;cui-preloader_muted&quot;: preloader.muted }\" class=\"cui-preloader\"><div class=\"cui-preloader__circle\"></div></div>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/preloader/template.jade
// module id = 852
// module chunks = 0